// extracted by mini-css-extract-plugin
export const footer = "Footer-module--footer--3mBiF";
export const copyright = "Footer-module--copyright--2GL1M";
export const contactLayout = "Footer-module--contactLayout--2TaB9";
export const footerLogo = "Footer-module--footerLogo--3FJKh";
export const contactLinks = "Footer-module--contactLinks--KS7d9";
export const contactLinksAddress = "Footer-module--contactLinksAddress--3-SU0";